import React, { useState } from 'react';
import './css/activitiesCard.scss';
import { GrAttachment, MdOutlineArrowRightAlt } from '../../../../../components/icons';
import ActivityModal from '../../ActivityModal/ActivityModal';
import useRedirect from '../../../../../components/customHooks/useRedirect';
// import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../../../common/common';
const ActivitiesCard = ({ data, type, reInitiateClick }) => {
  const { redirectTo } = useRedirect();
  const [modalShow, setModalShow] = useState(false);
  const click = () =>
    type == 'activitesCardBlue'
      ? redirectTo('caseDetails', '', '', `discussion_code=${data.referral_discussion_code}`)
      : setModalShow(true);
  return (
    <>
      <div
        className={`w-100 rounded text-start hsptlActivitesCard bg-white position-relative overflow-hidden shadow p-4 ${type}`}
      >
        {/* activitesCardYellow   activitesCardRed  activitesCardGreen  activitesCardBlue */}
        <div className="w-100 hsptlActivitesCardIn position-relative z-1 d-flex flex-column">
          <div
            className="d-flex align-items-center justify-content-between mb-2 cursorPointer"
            onClick={click}
          >
            <h5 className="text-black fw-semibold fs-5">
              {data.operation_type_name}
              &nbsp;&nbsp;&nbsp;
              <span className="border p-1 border-dark border-1 rounded">
                {data?.action_type_name}
              </span>
            </h5>
            <span className="fs-4 fw-normal hspltActivitesStts position-relative ps-4">
              {data.process_status_name}
            </span>
          </div>
          <h2 className="fs-16 text-black fw-medium mb-1 cursorPointer" onClick={click}>
            {reactHtmlParser(data.referral_case_subject)}
          </h2>
          <h4 className="fs-4 fw-medium text-black cursorPointer" onClick={click}>
            {data.referred_client_name}
          </h4>
          <div
            className="d-flex align-items-center justify-content-between mt-1 cursorPointer"
            onClick={click}
          >
            <h5 className="text-black fw-normal fs-5">
              {data.referred_date_format} | {data?.referral_discussion_code}
            </h5>
            <span className="text-black d-inline-flex align-items-center">
              <GrAttachment customClass={'fs-16 me-1'} /> {data.total_attachment}{' '}
            </span>
          </div>
          {(type == 'activitesCardRed' || type == 'activitesCardGreen') && (
            <div
              className="rounded btn transition cursorPointer mt-3 py-2 px-3 d-flex me-auto align-items-center justify-content-center gap-2 text-white"
              onClick={reInitiateClick}
            >
              Re Initialize <MdOutlineArrowRightAlt customClass="fs-4" />
            </div>
          )}
        </div>
      </div>
      <ActivityModal show={modalShow} onHide={() => setModalShow(false)} data={data} />
    </>
  );
};

export default ActivitiesCard;
